(function() {
  var __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  vtex.define('shipping/script/mixin/withGoogleMaps',['shipping/script/module/countryISOMap', 'shipping/script/module/googleRequiredFields', 'shipping/script/component/ShippingDataStore'], function(countryISOMap, checkRequiredFields, ShippingDataStore) {
    return function() {
      var getCountry, runGoogleAddressHandlers, validatePostalCode;
      countryISOMap = countryISOMap;
      checkRequiredFields = checkRequiredFields;
      this.startGoogleAddressSearch = function() {
        var options,
          _this = this;
        options = {
          types: [],
          componentRestrictions: {
            country: this.attr.countryRules.abbr || countryISOMap.getCountryISO2(this.attr.data.country)
          }
        };
        if (this.attr.geolocation) {
          options['bounds'] = this.attr.geolocation;
        }
        this.attr.autocomplete = new google.maps.places.Autocomplete(this.select('addressSearchSelector')[0], options);
        if (this.attr.autocompleteListerner) {
          this.attr.autocompleteListerner.remove();
        }
        return this.attr.autocompleteListerner = google.maps.event.addListener(this.attr.autocomplete, 'place_changed', function() {
          var googleAddress;
          googleAddress = _this.attr.autocomplete.getPlace();
          _this.attr.data.suggestedAddress.raw = googleAddress;
          return _this.selectSuggestedAddress();
        });
      };
      getCountry = function(googleAddress) {
        var countryInfo;
        countryInfo = _.find(googleAddress.address_components, function(c) {
          return __indexOf.call(c.types, 'country') >= 0;
        });
        if (countryInfo) {
          return countryISOMap.getCountryISO3(countryInfo.short_name);
        }
        return null;
      };
      this.getAddressFromGoogle = function(googleAddress, googleDataMap, fallbackCountry) {
        var address, component, country, location, matchRule, rule, _i, _j, _len, _len1, _ref;
        address = {};
        for (_i = 0, _len = googleDataMap.length; _i < _len; _i++) {
          rule = googleDataMap[_i];
          _ref = googleAddress.address_components;
          for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
            component = _ref[_j];
            matchRule = _.intersection(component.types, rule.types).length > 0;
            if (matchRule) {
              address[rule.value] = component[rule.length];
            }
          }
        }
        address = runGoogleAddressHandlers(address, googleDataMap, googleAddress);
        location = googleAddress.geometry.location;
        address.geoCoordinates = [_.isFunction(location.lng) ? location.lng() : location.lng, _.isFunction(location.lat) ? location.lat() : location.lat];
        country = getCountry(googleAddress);
        address.country = country ? country : fallbackCountry;
        address.addressQuery = googleAddress.formatted_address;
        return address;
      };
      runGoogleAddressHandlers = function(address, rules, googleAddress) {
        var rule, _i, _j, _k, _len, _len1, _len2;
        for (_i = 0, _len = rules.length; _i < _len; _i++) {
          rule = rules[_i];
          if (rule.handler) {
            address = rule.handler(address, googleAddress, 0);
          }
        }
        for (_j = 0, _len1 = rules.length; _j < _len1; _j++) {
          rule = rules[_j];
          if (rule.handler) {
            address = rule.handler(address, googleAddress, 1);
          }
        }
        for (_k = 0, _len2 = rules.length; _k < _len2; _k++) {
          rule = rules[_k];
          if (rule.handler) {
            address = rule.handler(address, googleAddress, 2);
          }
        }
        return address;
      };
      validatePostalCode = function(postalCode, postalCodeRegex) {
        if (postalCodeRegex) {
          return postalCodeRegex.test(postalCode);
        } else {
          return true;
        }
      };
      this.selectSuggestedAddress = function() {
        var address, countryRules, fallbackCountry, googleAddress, googleDataMap, postalCodeRegex, storeAcceptsGeoCoords, _ref;
        this.attr.data.invalidFields = [];
        countryRules = this.attr.countryRules;
        googleAddress = this.attr.data.suggestedAddress.raw;
        postalCodeRegex = countryRules.regexes['postalCode'];
        googleDataMap = countryRules.googleDataMap;
        fallbackCountry = countryRules.country;
        storeAcceptsGeoCoords = (__indexOf.call((_ref = this.attr.data.logisticsConfiguration) != null ? _ref.acceptSearchKeys : void 0, 'geoCoords') >= 0);
        if (!googleAddress.address_components) {
          return;
        }
        address = this.getAddressFromGoogle(googleAddress, googleDataMap, fallbackCountry);
        address.isPostalCodeValid = validatePostalCode(address.postalCode, postalCodeRegex);
        address.addressId = this.attr.data.addressId;
        this.attr.data.invalidFields = checkRequiredFields(address, googleDataMap, postalCodeRegex, storeAcceptsGeoCoords);
        if (storeAcceptsGeoCoords || this.attr.data.invalidFields.length === 0) {
          this.trigger('addressSearchStart.vtex');
          return this.sendGeoCoords(address);
        } else if (address.postalCode === '' || (address.postalCode == null)) {
          this.select('incompleteAddressData').hide();
          return this.select('addressNotDetailed').fadeIn();
        } else if (!address.isPostalCodeValid) {
          this.select('addressNotDetailed').hide();
          return this.select('incompleteAddressData').fadeIn();
        }
      };
      this.handleGeolocationError = function(error) {
        switch (error.code) {
          case 1:
            return console.log("Geolocation: PERMISSION_DENIED");
          case 2:
            return console.log("Geolocation: POSITION_UNAVAILABLE");
          case 3:
            return console.log("Geolocation: TIMEOUT");
          default:
            return console.log("Geolocation: ERROR");
        }
      };
      this.openGeolocationSearch = function() {
        this.getNavigatorCurrentPosition();
        if (window.vtex.maps.isGoogleMapsAPILoading && !window.vtex.maps.isGoogleMapsAPILoaded) {
          this.attr.data.loadingGeolocation = true;
          this.attr.data.showGeolocationSearch = false;
        } else {
          this.attr.data.showGeolocationSearch = true;
        }
        if (this.attr.isEnabled) {
          return this.render();
        }
      };
      this.getNavigatorCurrentPosition = function() {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(this.setGeolocation.bind(this), this.handleGeolocationError.bind(this), {
            enableHighAccuracy: true,
            maximumAge: 120 * 1000,
            timeout: 15 * 1000
          });
        } else {
          this.attr.geolocation = null;
        }
      };
      this.googleMapsAPILoaded = function() {
        this.attr.data.loadingGeolocation = false;
        this.attr.data.showGeolocationSearch = true;
        this.setAutocompleteBounds();
        if (this.attr.isEnabled) {
          return this.render();
        }
      };
      this.onSuggestedAddressLoaded = function(response) {
        var fallbackCountry, googleDataMap, suggestedAddress;
        if (response.status === "OK") {
          suggestedAddress = this.attr.data.suggestedAddress;
          suggestedAddress.raw = _.find(response.results, function(address) {
            var hasPostalCode;
            hasPostalCode = _.any(address.address_components, function(a) {
              return __indexOf.call(a.types, "postal_code") >= 0;
            });
            return address.geometry.location_type === "ROOFTOP" && hasPostalCode;
          });
          if (suggestedAddress.raw) {
            googleDataMap = this.attr.countryRules.googleDataMap;
            fallbackCountry = this.attr.countryRules.country;
            suggestedAddress.formatted = this.getAddressFromGoogle(suggestedAddress.raw, googleDataMap, fallbackCountry);
            this.select('formattedAddressSugestionSelector').text("" + suggestedAddress.formatted.street + ", " + suggestedAddress.formatted.number + ", " + suggestedAddress.formatted.city);
            return this.select('textAddressSuggestionSelector').fadeIn();
          } else {
            return suggestedAddress = {
              raw: null,
              formatted: null,
              position: null
            };
          }
        } else if (response.status === "OVER_QUERY_LIMIT") {
          return console.log("OVER_QUERY_LIMIT");
        }
      };
      this.onSuggestedAddressError = function(error) {
        console.log("REVERSE GEOCODE ERROR");
        return console.log(error);
      };
      this.getSuggestedAddress = function(lat, lng) {
        return $.ajax({
          url: "//maps.googleapis.com/maps/api/geocode/json?latlng=" + lat + "," + lng,
          success: this.onSuggestedAddressLoaded.bind(this),
          error: this.onSuggestedAddressError.bind(this)
        });
      };
      this.setAutocompleteBounds = function() {
        var coord, _ref, _ref1;
        if ((_ref = this.attr.data.suggestedAddress) != null ? _ref.position : void 0) {
          coord = new google.maps.LatLng(this.attr.data.suggestedAddress.position.coords.latitude, this.attr.data.suggestedAddress.position.coords.longitude);
          this.attr.geolocation = google.maps.LatLngBounds(coord, coord);
          return (_ref1 = this.attr.autocomplete) != null ? _ref1.setBounds(this.attr.geolocation) : void 0;
        }
      };
      this.setGeolocation = function(position) {
        this.attr.data.suggestedAddress.position = position;
        this.getSuggestedAddress(position.coords.latitude, position.coords.longitude);
        if (window.vtex.maps.isGoogleMapsAPILoaded) {
          return this.setAutocompleteBounds();
        }
      };
      return this.sendGeoCoords = function(address) {
        var _ref,
          _this = this;
        if (((_ref = this.attr.requestSendGeoCoords) != null ? _ref.abort : void 0) != null) {
          this.attr.requestSendGeoCoords.abort();
        }
        if (!address.isPostalCodeValid) {
          address = _.extend({}, address, {
            postalCode: null
          });
        }
        return this.attr.requestSendGeoCoords = ShippingDataStore.sendAttachment({
          address: address,
          clearAddressIfPostalCodeNotFound: false
        }).then((function(orderForm) {
          return _this.handleAddressSearch(_.extend({}, orderForm.shippingData.address));
        }), (function() {
          return _this.handleAddressSearchError(address);
        }));
      };
    };
  });

}).call(this);

